import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Database } from 'sql.js'
import * as path from "path";
import {Parser} from "xml2js";
import * as fs from "fs";

/*
  Generated class for the ImportProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ImportProvider {


  private parser: Parser;
  private appDir: string = path.dirname(require.main.filename);
  private database;

  private contacts: Array<any> = [];
  private bewertungen: Array<Array<any>> = [];

  constructor(public http: HttpClient) {
    console.log('Hello ImportProvider Provider');

    //init bewertungen

    /*
    GRÜN -ROT
     */
    this.bewertungen['d2fb3aa9-a3f1-1f12-8a54-4a4ddad8aa4b'] = [];
    this.bewertungen['d2fb3aa9-a3f1-1f12-8a54-4a4ddad8aa4b']['deff4fcd-faa6-4a98-8dba-8da5b9a2a29b'] = {title: 'Grün', color: '#84D922', danger: 0};
    this.bewertungen['d2fb3aa9-a3f1-1f12-8a54-4a4ddad8aa4b']['2ef6af1e-b239-a70c-826b-e5ae62efb96f'] = {title: 'Rot', color: '#D7243A', danger: 8};

    /*
    JA - NEIN
     */
    this.bewertungen['defb3ab9-b3f1-4f02-8a54-4a4defd8aa5b'] = [];
    this.bewertungen['defb3ab9-b3f1-4f02-8a54-4a4defd8aa5b']['def94fcd-fca6-4698-8db2-8da5c9aea29b'] = {title: 'Ja', color: '#AEAEAE', danger: 0};
    this.bewertungen['defb3ab9-b3f1-4f02-8a54-4a4defd8aa5b']['def68f1e-b269-470c-8263-e53e625fb96b'] = {title: 'Nein', color: '#AEAEAE', danger: 0};

    /*
    GRÜN - GELB - ROT
     */
    this.bewertungen['defa3ab9-b3f1-4f02-8a54-4a4defd8aa5b'] = [];
    this.bewertungen['defa3ab9-b3f1-4f02-8a54-4a4defd8aa5b']['def94fc3-fca6-4698-8db2-8da5c9aea29b'] = {title: 'Grün', color: '#84D922', danger: 0};
    this.bewertungen['defa3ab9-b3f1-4f02-8a54-4a4defd8aa5b']['def29974-2436-4b2b-bcf7-58b696bbb64b'] = {title: 'Gelb', color: '#FCF381', danger: 4};
    this.bewertungen['defa3ab9-b3f1-4f02-8a54-4a4defd8aa5b']['def68f10-b269-470c-8263-d53e625fb96b'] = {title: 'Rot', color: '#D7243A', danger: 8};

    /*
    I.O. - N.I.O. - ZU BEHEBEN
     */
    this.bewertungen['65f3758e-cc5f-4cb1-81a1-0d9310afeb88'] = [];
    this.bewertungen['65f3758e-cc5f-4cb1-81a1-0d9310afeb88']['c683052b-36a8-4bcf-a32c-dbaeebc9b421'] = {title: 'i.O.', color: '#84D922', danger: 0};
    this.bewertungen['65f3758e-cc5f-4cb1-81a1-0d9310afeb88']['78d278d0-4304-4c7a-8dee-4410cdbef046'] = {title: 'n.i.O.', color: '#FF9900', danger: 7};
    this.bewertungen['65f3758e-cc5f-4cb1-81a1-0d9310afeb88']['f7edb1c9-8610-4341-b58c-9d0bc73bb7ae'] = {title: 'zu beheben', color: '#D7243A', danger: 7};

    /*
    I.O. - N.I.O. - ZU BEHEBEN - NICHT ZUTREFFEND
     */
    this.bewertungen['fa2a3ab0-b3fa-4f02-8a54-4a4defd8aa5b'] = [];
    this.bewertungen['fa2a3ab0-b3fa-4f02-8a54-4a4defd8aa5b']['cda54fc3-fca6-4698-8db2-8da5c9aea29b'] = {title: 'i.O.', color: '#84D922', danger: 0};
    this.bewertungen['fa2a3ab0-b3fa-4f02-8a54-4a4defd8aa5b']['fec2b914-2436-4b2b-bcf7-58b696bbb64b'] = {title: 'n.i.O.', color: '#FF9900', danger: 6};
    this.bewertungen['fa2a3ab0-b3fa-4f02-8a54-4a4defd8aa5b']['a0d2b8ac-f1cd-d0ac-d5c2-37a241da058c'] = {title: 'zu beheben', color: '#D7243A', danger: 7};
    this.bewertungen['fa2a3ab0-b3fa-4f02-8a54-4a4defd8aa5b']['cdaf5ac1-a737-11e6-9598-0800200c9a66'] = {title: 'nicht zutreffend', color: '#AEAEAE', danger: 0};

    /*
    KEINE GEFÄHRDUNG - GERINGE GEFÄHRDUNG - ERHÖHTE GEFÄHRDUNG - HOHE GEFÄHRDUNG - GEFAHR
     */
    this.bewertungen['def9ca10-1d7b-47c0-a17f-a1a1cc90e85b'] = [];
    this.bewertungen['def9ca10-1d7b-47c0-a17f-a1a1cc90e85b']['def600f3-021d-4ddc-a9cd-34ea907df4cb'] = {title: 'Keine Gefährdung', color: '#84D922', danger: 0};
    this.bewertungen['def9ca10-1d7b-47c0-a17f-a1a1cc90e85b']['def07eca-9094-4c24-a11f-478c6095769b'] = {title: 'geringe Gefährdung', color: '#FCF381', danger: 4};
    this.bewertungen['def9ca10-1d7b-47c0-a17f-a1a1cc90e85b']['def7f0ad-5f94-4fa4-92ea-76832db10c1b'] = {title: 'erhöhte Gefährdung', color: '#C78821', danger: 5};
    this.bewertungen['def9ca10-1d7b-47c0-a17f-a1a1cc90e85b']['def1d5b7-fbbd-44a0-ad97-18d5889f569b'] = {title: 'hohe Gefährdung', color: '#D7243A', danger: 7};
    this.bewertungen['def9ca10-1d7b-47c0-a17f-a1a1cc90e85b']['def41794-bb98-41e2-9a4b-f6367653e46b'] = {title: 'Gefahr', color: '#9B2FFB', danger: 8};


  }


  public run(file: File): void {
    // fs.readdir(this.filePath, (err, files) => {
    //   if(err){
    //     var error = 'error while reading directory entries';
    //     console.log(error);
    //     console.log(err);
    //   }
    //   else {
    //     files.forEach((fileName) => {
    //       if(fileName.substr(fileName.lastIndexOf('.')) === '.xml'){
    //         this.parse(fileName);
    //       }
    //     })
    //   }
    // })

    let fileReader:FileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onloadend = (e) => function(e){
      this.parse(null, fileReader.result);
    }

  }

  public parse(fileName?: string, content?: any): void {
    // let pathToFile = this.appDir+'/'+this.filePath+'/'+fileName;
    // let content = fs.readFileSync(pathToFile).toString('utf-8');


    new Parser({
      explicitArray: false
    }).parseString(content, (err, result) => {
      if(!err){
        // console.log(result);

        let pruefung: any = {};
        pruefung.docType = 'audit';
        pruefung.importFrom = 'cheqsite';
        pruefung._id = result.inspection.id;
        pruefung.anmerkungen = [result.inspection.comment];
        pruefung.erstellungsDatum = result.inspection.inspection_date_start;
        pruefung.reportsRAW = [];
        pruefung.reports = [];

        //contact import start
        let contacts = Array.isArray(result.inspection.contacts.contact) ? result.inspection.contacts.contact : [result.inspection.contacts.contact];
        for(let contact of contacts){
          if(contact.is_customer === 'true'){
            //kunde!!!
            pruefung.customerId = this.importContactIfNotExists(contact, 1, pruefung._id);
          }else {
            this.importContactIfNotExists(contact, 2, pruefung._id);
          }
        }
        //contact import end


        let protokolle = [];

        if(result.inspection.hasOwnProperty('inspectionitems')){
          if(!Array.isArray(result.inspection.inspectionitems.inspectionitem)){
            result.inspection.inspectionitems.inspectionitem = [result.inspection.inspectionitems.inspectionitem];
          }
        }
        else {
          throw new Error('no inspectionitems');
        }

        let _protokolle = result.inspection.inspectionitems.inspectionitem;
        for(let _protokoll of _protokolle){
          let protokoll:any = {};

          protokoll.docType = 'protocol';
          protokoll._id = _protokoll.id;
          protokoll.title = _protokoll.title;
          protokoll.masterData = [];
          protokoll.sections = [];
          protokoll.importFrom = 'cheqsite';
          protokoll[protokoll.importFrom] = _protokoll;

          let _inspectionList = _protokoll.inspectionlists.inspectionlist;

          //Stammdaten import start
          if(!Array.isArray(_inspectionList.labelvalues.labelvalue)){
            _inspectionList.labelvalues.labelvalue = [_inspectionList.labelvalues.labelvalue];
          }

          for(let _stammdate of _inspectionList.labelvalues.labelvalue){
            if(_stammdate.label_res === 'androidres_pruefliste_attrib1_regalgang'){
              protokoll.location = _stammdate.value;
            }

            if(_stammdate.label.toLowerCase().indexOf('standort') === -1){
              protokoll.masterData.push({type: _stammdate.value_type, title: _stammdate.label, value: _stammdate.value, list: []});
            }
          }
          //Stammdaten import end

          //Pruefpunkte import start
          if(!Array.isArray(_inspectionList.inspectionsections.inspectionsection)){
            _inspectionList.inspectionsections.inspectionsection = [_inspectionList.inspectionsections.inspectionsection];
          }

          for(let _section of _inspectionList.inspectionsections.inspectionsection){

            if(_section.hasOwnProperty('inspectionpoints') && _section.inspectionpoints.hasOwnProperty('inspectionpoint')){
              let row: any = {};
              row.title = _section.title;
              row.inspectionPoints = [];

              if(!Array.isArray(_section.inspectionpoints.inspectionpoint)){
                _section.inspectionpoints.inspectionpoint = [_section.inspectionpoints.inspectionpoint];
              }



              for(let _pruefpunkt of _section.inspectionpoints.inspectionpoint){
                let propertyName = _pruefpunkt.id;
                let title = _pruefpunkt.title;
                let value = null;
                if(_pruefpunkt.assessment_id){
                  value = this.processPruefpunktValue(_pruefpunkt.assessmentlist_id, _pruefpunkt.assessment_id);
                }

                let reviews = this.processPreuefpunktBewertungen(_pruefpunkt.assessmentlist_id);
                let measure  = _pruefpunkt.measure;
                let comments = _pruefpunkt.comment.trim().length > 0 ? [_pruefpunkt.comment.trim()] : [];
                let pictures = [];

                if(_pruefpunkt.hasOwnProperty('fileattachments')){

                  if(!Array.isArray(_pruefpunkt.fileattachments.fileattachment)){
                    _pruefpunkt.fileattachments.fileattachment = [_pruefpunkt.fileattachments.fileattachment];
                  }

                  for(let _fileattachment of _pruefpunkt.fileattachments.fileattachment){
                    pictures.push(_fileattachment.id);

                  }
                }
                row.inspectionPoints.push({
                  propertyName: propertyName,
                  title: title,
                  value: value,
                  reviews: reviews,
                  measure: measure,
                  comments: comments,
                  pictures: pictures
                });
              }
              protokoll.sections.push(row);
            }


          }
          //Pruefpunkte import end

          pruefung.reports.push(protokoll._id);
          protokolle.push(protokoll);
        }


        pruefung.reportsRAW = protokolle;
        delete result.inspection.contacts;
        delete result.inspection.inspectionitems;
        pruefung[pruefung.importFrom] = result;
        // console.dir(pruefung);
        this.importPruefungIfNotExists(pruefung);
      }
    });
  }

  private importContactIfNotExists(_contact: any, type: number, pruefungId: string): string {

    let contact:any = {};


    contact.docType = 'contact';
    contact.type = type;

    contact.company = _contact.company;
    contact.street = _contact.street;
    contact.web = _contact.web;

    contact.zip = _contact.zip_code;
    contact.city = _contact.city;
    contact.name_contactperson = _contact.name_contactperson.trim();
    contact.firstName = _contact.name_contactperson.substring(0, _contact.name_contactperson.lastIndexOf(' '));
    contact.lastName = _contact.name_contactperson.substring(_contact.name_contactperson.lastIndexOf(' ')+1);

    contact.fax = _contact.fax_contactperson.length > 0 ? _contact.fax_contactperson : _contact.fax
    contact.tel = _contact.phone_contactperson.length > 0 ? _contact.phone_contactperson : _contact.phone;
    contact.mail = _contact.email_contactperson.length > 0 ? _contact.email_contactperson : _contact.email;
    // this.dataProvider.insertDocumentIfNotExist(contact, _contact.id)
    //     .then((success) => {
    //         console.log('successfully insert imported contact: ');
    //         console.dir(success);
    //     }, (error) => {
    //         console.log('error while inserting imported contact ');
    //         console.dir(error);
    //     })



    if(this.contactAlreadyExists(contact) !== null){
      let foundedContact = this.contactAlreadyExists(contact);
      contact.id = foundedContact;
    }
    else {
      this.contacts[_contact.id] = JSON.parse(JSON.stringify(contact));
      contact.id = _contact.id;
      contact.importFrom = 'cheqsite';
      contact[contact.importFrom] = _contact;

      if(_contact.hasOwnProperty('fileattachments') && _contact.fileattachments.hasOwnProperty('fileattachment')){
        var imageId = _contact.fileattachments.fileattachment.id;
        var imageExtension = _contact.fileattachments.fileattachment.extension;
        contact.logo = imageId + '.' + imageExtension;
      }
    }

    console.log(contact);

    return contact._id

    // this.imageLoader(pruefungId, imageId, imageExtension);

    // return this.database.putIfNotExists(_contact.id, contact);
    // this.database.post(contact);
  }

  private contactAlreadyExists(contact): string {

    for(let contactId in this.contacts){

      let _contact = this.contacts[contactId];
      if(JSON.stringify(_contact) === JSON.stringify(contact)){
        return contactId;
      }
    }

    // for(let keyValue of this.contacts.entries()){
    //   let value = keyValue[1];
    //   if(value === contact){
    //     return keyValue
    //   }
    // }
    return null
  }

  private importPruefungIfNotExists(pruefung){

    // let protokollPromises = [];
    // for(let protokoll of pruefung.protokolleRaw){
    //     protokollPromises.push(this.dataProvider.insertDocumentIfNotExist(protokoll));
    // }
    //
    // Promise.all(protokollPromises)
    //     .then((success) => {
    //         console.log('successfully inserted protokolls');
    //         delete pruefung.protokolleRaw;
    //         this.dataProvider.insertDocumentIfNotExist(pruefung)
    //             .then((success) => {
    //                 console.log('successfully inserted pruefung');
    //             }, (error) => {
    //                 console.log('error while inserting pruefung');
    //                 console.dir(error);
    //             })
    //     }, (error) => {
    //         console.log('error while inserting protokolls');
    //         console.dir(error);
    //     })

  }

  private processPruefpunktValue(assessmentlist_id: string, assessment_id: string): string {
    return this.bewertungen[assessmentlist_id][assessment_id];
  }

  private processPreuefpunktBewertungen(assessmentlist_id): any{
    let reviews: Array<any> = [];

    for(let key in this.bewertungen[assessmentlist_id]){
      reviews.push(this.bewertungen[assessmentlist_id][key]);
    }
    return reviews;
  }

  private imageLoader(pruefungId, imageId?, imageExtension?): void {
    // let imageFile = this.filePath + '/inspection_' + pruefungId + '/' + imageId + '.' + imageExtension;
    // let image = fs.readFileSync(imageFile).toString('utf-8');
    // console.log(image);
  }

}



// WEBPACK FOOTER //
// ./src/providers/import/import.ts